import { Typography } from "@material-ui/core"
import type { CSSProperties, ForwardedRef, MouseEvent, ReactElement, ReactNode } from "react"
import { forwardRef } from "react"

import "./typography.styles.scss"

export interface ITypographyProps {
  children?: ReactNode
  className?: string
  style?: CSSProperties
  onClick?: (event: MouseEvent<Element>) => void
  onChange?: (event: any) => void
}

export function Header1({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="h1" className={className}>
      {children}
    </Typography>
  )
}

export function Header2({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="h2" className={className}>
      {children}
    </Typography>
  )
}

export function Header3({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="h3" className={className}>
      {children}
    </Typography>
  )
}

export function Header4({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="h4" className={className}>
      {children}
    </Typography>
  )
}

export function Header5({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="h5" className={className}>
      {children}
    </Typography>
  )
}

export function Header6({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="h6" className={className}>
      {children}
    </Typography>
  )
}

export const Body1 = forwardRef<HTMLParagraphElement, ITypographyProps>(
  ({ children, className, style, onClick, onChange }: ITypographyProps, ref: ForwardedRef<HTMLParagraphElement>) => {
    return (
      <Typography
        onClick={onClick}
        style={style}
        variant="body1"
        className={className}
        onChange={onChange}
        paragraph
        ref={ref}
      >
        {children}
      </Typography>
    )
  }
)

export function Body2({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="body2" className={className}>
      {children}
    </Typography>
  )
}

export function SubTitle1({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="subtitle1" className={className}>
      {children}
    </Typography>
  )
}

export function Caption({ children, className, style, onClick }: ITypographyProps): ReactElement {
  return (
    <Typography onClick={onClick} style={style} variant="caption" className={className}>
      {children}
    </Typography>
  )
}
